<template>
  <section>
    <div class="container clearfix py-5">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 col-12">
          <h1>Misyonumuz</h1>
          <p class="text-justify lead">
            Toplumsal cinsiyet eşitliğinin sağlandığı, kadınların ve erkeklerin
            iş hayatına ve kararlara eşit ve etkin katıldığı toplumlarda;
            yurttaşlar kazanıyor, ülke kazanıyor, iş dünyası kazanıyor. Türkiye
            ise dünyada toplumsal cinsiyet eşitliğinde son sıralarda yer alıyor.
            Bu fotoğrafı bir an
            <br />
            <br />önce değiştirmeye, özel sektörü değişimin öncüsü olarak
            harekete geçirmeye ihtiyacımız var. Toplumsal cinsiyet eşitliğinin
            sağlanması için çalışırken, yalnızca kendimizden değil, birlikte iş
            yaptığımız tedarikçilerimiz, ajanslarımız, bayilerimiz yani
            ekosistemimizden de sorumlu olduğumuza inanıyor ve büyük değişimin
            ancak birlikte mümkün olduğunu düşünüyoruz. Biz aralarında iş bağı
            olan şirketler olarak, sivil toplum paydaşlarının da desteğiyle, bu
            amaçla Birlikte Güçlüyüz platformunu kurduk. Platformun merkezine
            ise iki temel felsefeyi aldık: “değiş” ve “etkile”.
            <br />
            <br />Birlikte Güçlüyüz Platformu olarak; kendi şirketlerimizde
            kadınların istihdama aktif katılımları, istihdamda yükselmeleri ve
            karar alma süreçlerinin tam ve eşit bir parçası olmaları için
            çalışacağımızı, ekosistemimizdeki diğer şirketleri de kendi
            şirketlerinde bu değişimi gerçekleştirmeleri için teşvik edeceğimizi
            ve destek olacağımızı taahhüt ediyoruz. Birlikte Güçlüyüz platformu,
            tüm iş dünyasını toplumsal cinsiyet eşitliğinin sağlanması için
            kendisini değiştirmeye ve ekosistemini etkilemeye çağırıyor.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    this.$root.$emit("loaded");
  }
};
</script>

<style></style>
